'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jwtDecode = require('jwt-decode');
var uuid = require('uuid');
var axios = require('axios');
var store = require('store2');
var broadcastChannel$1 = require('broadcast-channel');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var jwtDecode__default = /*#__PURE__*/_interopDefaultLegacy(jwtDecode);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var store__default = /*#__PURE__*/_interopDefaultLegacy(store);

var REQUEST = 'network/REQUEST';
var REQUEST_START = 'network/REQUEST/start';
var REQUEST_SUCCESS = 'network/REQUEST/success';
var REQUEST_ERROR = 'network/REQUEST/error';
var SET_SCOPE = 'network/SET_SCOPE';
var GET_TOKEN = 'network/GET_TOKEN';
var GET_TOKEN_START = 'network/GET_TOKEN/start';
var GET_TOKEN_SUCCESS = 'network/GET_TOKEN/success';
var GET_TOKEN_ERROR = 'network/GET_TOKEN/error';
var REFRESH_TOKEN = 'network/REFRESH_TOKEN';
var REFRESH_TOKEN_START = 'network/REFRESH_TOKEN/start';
var REFRESH_TOKEN_SUCCESS = 'network/REFRESH_TOKEN/success';
var REFRESH_TOKEN_ERROR = 'network/REFRESH_TOKEN/error';
var STORE_TOKENS = 'network/STORE_TOKENS';
var STORE_TOKENS_START = 'network/STORE_TOKENS/start';
var STORE_TOKENS_SUCCESS = 'network/STORE_TOKENS/success';
var STORE_TOKENS_ERROR = 'network/STORE_TOKENS/error';
var REMOVE_TOKENS = 'network/REMOVE_TOKENS';
var REMOVE_TOKENS_START = 'network/REMOVE_TOKENS/start';
var REMOVE_TOKENS_SUCCESS = 'network/REMOVE_TOKENS/success';
var REMOVE_TOKENS_ERROR = 'network/REMOVE_TOKENS/error';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  access_token: {},
  refresh_token: {},
  scope: 'user'
};
var reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_SCOPE:
      return Object.assign({}, state, {
        scope: action.scope
      });

    case STORE_TOKENS_START:
      return Object.assign({}, state, {
        access_token: Object.assign({}, state.access_token, _defineProperty({}, action.tokenKey, action.access_token || state.access_token[action.tokenKey] || null)),
        refresh_token: Object.assign({}, state.refresh_token, _defineProperty({}, action.tokenKey, action.refresh_token || state.refresh_token[action.tokenKey] || null))
      });

    case REMOVE_TOKENS_START:
      return Object.assign({}, state, {
        access_token: Object.assign({}, state.access_token, _defineProperty({}, action.tokenKey, null)),
        refresh_token: Object.assign({}, state.access_token, _defineProperty({}, action.tokenKey, null))
      });

    default:
      return state;
  }
});

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var Request = /*#__PURE__*/function () {
  function Request() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Request);

    var _params$retryDelay = params.retryDelay,
        retryDelay = _params$retryDelay === void 0 ? 1000 : _params$retryDelay,
        _params$concurrentReq = params.concurrentRequests,
        concurrentRequests = _params$concurrentReq === void 0 ? 1 : _params$concurrentReq,
        transport = params.transport,
        preRequestHook = params.preRequestHook,
        postRequestHook = params.postRequestHook;
    this.retryDelay = retryDelay;
    this.concurrentRequests = concurrentRequests;
    this.requests = {};
    this.transport = transport || axios__default['default'];
    this.preRequestHook = preRequestHook || async(function (config) {
      return config;
    });
    this.postRequestHook = postRequestHook || async(function (_ref) {
      var response = _ref.response;
      return response;
    });
    this.session_id = null;
  }

  _createClass(Request, [{
    key: "send",
    value: function send(_ref2) {
      var config = _ref2.config,
          _ref2$onStart = _ref2.onStart,
          onStart = _ref2$onStart === void 0 ? function () {} : _ref2$onStart,
          _ref2$onSuccess = _ref2.onSuccess,
          onSuccess = _ref2$onSuccess === void 0 ? function () {} : _ref2$onSuccess,
          _ref2$onError = _ref2.onError,
          onError = _ref2$onError === void 0 ? function () {} : _ref2$onError;

      try {
        var _this2 = this;

        if (!_this2.session_id) {
          var session_id = store__default['default'].session.get('session_id');

          if (!session_id) {
            session_id = uuid.v4();
            store__default['default'].session.set('session_id', session_id);
          }

          _this2.session_id = session_id;
        }

        var id = config.id || uuid.v4();
        config.id = id;
        return _await(_this2.preRequestHook(config), function (_this$preRequestHook) {
          config = _this$preRequestHook;
          return _await(onStart({
            id: id,
            config: config
          }), function () {
            var _exit = false;
            var requestInProgress = true;
            return _for(function () {
              return !_exit && !!requestInProgress;
            }, void 0, function () {
              var requestsInProgress = Object.keys(_this2.requests).length;
              var isRequestQueueReady = requestsInProgress < _this2.concurrentRequests;
              return _invoke(function () {
                if (isRequestQueueReady) {
                  return _catch(function () {
                    if (!config) {
                      throw Error('config must be provided');
                    }

                    if (config.headers && !config.headers['Session-ID']) {
                      config.headers['Session-ID'] = _this2.session_id;
                    }

                    _this2.requests[id] = config;
                    return _await(_this2.transport(config), function (response) {
                      var _response, _response$data;

                      if (!response || !response.data) {
                        throw {
                          message: 'no data in response',
                          response: response
                        };
                      }

                      if ((_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.error) {
                        throw response.data;
                      }

                      requestInProgress = false;
                      return _await(_this2.postRequestHook({
                        config: config,
                        response: response
                      }), function (_this$postRequestHook) {
                        response = _this$postRequestHook;
                        delete _this2.requests[id];
                        return _await(onSuccess({
                          id: id,
                          response: response,
                          config: config
                        }), function () {
                          _exit = true;
                          return response;
                        });
                      });
                    });
                  }, function (error) {
                    requestInProgress = false;
                    delete _this2.requests[id];
                    return _await(onError({
                      id: id,
                      error: error,
                      config: config
                    }), function () {
                      throw error;
                    });
                  });
                }
              }, function (_result) {
                return _exit ? _result : _awaitIgnored(_this2.wait(_this2.retryDelay));
              });
            });
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, {
    key: "wait",
    value: function wait(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }]);

  return Request;
}();

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _empty() {}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    var observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

var _Pact = /*#__PURE__*/function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;

    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        var value = _this.v;

        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}();

function _isSettledPact(thenable) {
  return thenable instanceof _Pact && thenable.s & 1;
}

function _for(test, update, body) {
  var stage;

  for (;;) {
    var shouldContinue = test();

    if (_isSettledPact(shouldContinue)) {
      shouldContinue = shouldContinue.v;
    }

    if (!shouldContinue) {
      return result;
    }

    if (shouldContinue.then) {
      stage = 0;
      break;
    }

    var result = body();

    if (result && result.then) {
      if (_isSettledPact(result)) {
        result = result.s;
      } else {
        stage = 1;
        break;
      }
    }

    if (update) {
      var updateValue = update();

      if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
        stage = 2;
        break;
      }
    }
  }

  var pact = new _Pact();

  var reject = _settle.bind(null, pact, 2);

  (stage === 0 ? shouldContinue.then(_resumeAfterTest) : stage === 1 ? result.then(_resumeAfterBody) : updateValue.then(_resumeAfterUpdate)).then(void 0, reject);
  return pact;

  function _resumeAfterBody(value) {
    result = value;

    do {
      if (update) {
        updateValue = update();

        if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
          updateValue.then(_resumeAfterUpdate).then(void 0, reject);
          return;
        }
      }

      shouldContinue = test();

      if (!shouldContinue || _isSettledPact(shouldContinue) && !shouldContinue.v) {
        _settle(pact, 1, result);

        return;
      }

      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
        return;
      }

      result = body();

      if (_isSettledPact(result)) {
        result = result.v;
      }
    } while (!result || !result.then);

    result.then(_resumeAfterBody).then(void 0, reject);
  }

  function _resumeAfterTest(shouldContinue) {
    if (shouldContinue) {
      result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
      } else {
        _resumeAfterBody(result);
      }
    } else {
      _settle(pact, 1, result);
    }
  }

  function _resumeAfterUpdate() {
    if (shouldContinue = test()) {
      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
      } else {
        _resumeAfterTest(shouldContinue);
      }
    } else {
      _settle(pact, 1, result);
    }
  }
}

var isExpired = (function (encodedToken) {
  var refreshThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var decodedToken = jwtDecode__default['default'](encodedToken);
  var timeNow = Math.round(Date.now().valueOf() / 1000);
  var expiryTime = decodedToken.exp - timeNow;
  return expiryTime - refreshThreshold < 0;
});

function _await$1(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var storeTokens = _async(function (_ref) {
  var dispatch = _ref.dispatch,
      tokens = _ref.tokens,
      tokenKey = _ref.tokenKey;

  try {
    dispatch(Object.assign({
      type: STORE_TOKENS_START
    }, tokens, {
      tokenKey: tokenKey
    }));
    dispatch({
      type: STORE_TOKENS_SUCCESS
    });
  } catch (error) {
    dispatch({
      type: STORE_TOKENS_ERROR,
      error: error
    });
  }

  return _await$1();
});

function _await$2(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async$1(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var removeTokens = _async$1(function (_ref) {
  var dispatch = _ref.dispatch,
      tokens = _ref.tokens,
      tokenKey = _ref.tokenKey;

  try {
    dispatch({
      type: REMOVE_TOKENS_START,
      tokenKey: tokenKey
    });
    dispatch({
      type: REMOVE_TOKENS_SUCCESS
    });
  } catch (error) {
    dispatch({
      type: REMOVE_TOKENS_ERROR,
      error: error
    });
  }

  return _await$2();
});

function _await$3(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async$2(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var refreshToken = _async$2(function (_ref) {
  var refreshTokenAdapters = _ref.refreshTokenAdapters,
      state = _ref.state,
      dispatch = _ref.dispatch,
      request = _ref.request,
      tokenKey = _ref.tokenKey;
  var refreshConfig = refreshTokenAdapters.request({
    access_token: state._network.access_token[tokenKey],
    refresh_token: state._network.refresh_token[tokenKey],
    decode: function decode(encodedToken) {
      return jwtDecode__default['default'](encodedToken);
    },
    scope: state._network.scope,
    state: state
  });
  return _await$3(request.send({
    config: refreshConfig,
    onStart: function onStart(payload) {
      dispatch(Object.assign({
        type: REFRESH_TOKEN_START
      }, payload));
    },
    onSuccess: function onSuccess(payload) {
      dispatch(Object.assign({
        type: REFRESH_TOKEN_SUCCESS
      }, payload));
    },
    onError: function onError(payload) {
      dispatch(Object.assign({
        type: REFRESH_TOKEN_ERROR
      }, payload));
    }
  }), function (refreshResponse) {
    var parsedRefreshTokens = refreshTokenAdapters.response({
      data: refreshResponse.data,
      state: state
    });
    return _await$3(storeTokens({
      dispatch: dispatch,
      tokens: parsedRefreshTokens,
      tokenKey: tokenKey
    }), function () {
      return parsedRefreshTokens;
    });
  });
});

var receiver = function receiver(_ref) {
  var data = _ref.data,
      channelId = _ref.channelId,
      subscribe = _ref.subscribe,
      onSubscribeChange = _ref.onSubscribeChange,
      _ref$onInit = _ref.onInit,
      onInit = _ref$onInit === void 0 ? function () {} : _ref$onInit,
      _ref$custom = _ref.custom,
      custom = _ref$custom === void 0 ? {} : _ref$custom;

  if (!channelId) {
    throw new Error('unable to determine channel id');
  }

  var NetworkCommunication = new broadcastChannel$1.BroadcastChannel(channelId, {
    webWorkerSupport: false
  });
  var unsubscribe = subscribe(function () {
    onSubscribeChange({
      unsubscribe: custom.unsubscribe || unsubscribe,
      data: data,
      NetworkCommunication: NetworkCommunication
    });
  });
  onInit({
    data: data
  });
};

var sender = function sender(_ref2) {
  var config = _ref2.config,
      channelId = _ref2.channelId,
      _ref2$custom = _ref2.custom,
      custom = _ref2$custom === void 0 ? {} : _ref2$custom;
  var defaults = {
    broadcastChannelOptions: {
      webWorkerSupport: false
    },
    onMessageParser: function onMessageParser(_ref3) {
      var id = _ref3.id,
          message = _ref3.message;

      if (id === message.id) {
        return message.payload.response;
      }

      return false;
    },
    postMessageConstructor: function postMessageConstructor(_ref4) {
      var config = _ref4.config,
          target = _ref4.target,
          origin = _ref4.origin;
      var payload = {
        type: REQUEST,
        id: config.id,
        config: config
      };

      if (target) {
        payload.target = target;
      }

      if (origin) {
        payload.origin = origin;
      }

      return payload;
    }
  };
  var broadcastChannelOptions = custom.broadcastChannelOptions || defaults.broadcastChannelOptions;
  var onMessageParser = custom.onMessageParser || defaults.onMessageParser;
  var postMessageConstructor = custom.postMessageConstructor || defaults.postMessageConstructor;
  return new Promise(function (resolve, reject) {
    try {
      if (!channelId) {
        throw new Error('unable to obtain channel id');
      }

      var NetworkCommunication = new broadcastChannel$1.BroadcastChannel(channelId, broadcastChannelOptions);

      NetworkCommunication.onmessage = function (message) {
        var response = onMessageParser({
          id: config.id,
          message: message
        });

        if (response) {
          resolve(response);
        }
      };

      var message = postMessageConstructor({
        config: config,
        target: custom.target,
        origin: custom.origin
      });
      NetworkCommunication.postMessage(message);
    } catch (error) {
      reject(error);
    }
  });
};

var broadcastChannel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  receiver: receiver,
  sender: sender
});

function _await$4(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var request = null;

function _empty$1() {}

var networkMiddleware = function networkMiddleware(_ref) {
  var accessTokenAdapters = _ref.accessTokenAdapters,
      refreshTokenAdapters = _ref.refreshTokenAdapters,
      _ref$tokenKey = _ref.tokenKey,
      tokenKey = _ref$tokenKey === void 0 ? 'default' : _ref$tokenKey,
      transport = _ref.transport,
      _ref$preRequestHook = _ref.preRequestHook,
      preRequestHook = _ref$preRequestHook === void 0 ? function (config) {
    return _await$4(config);
  } : _ref$preRequestHook,
      _ref$postRequestHook = _ref.postRequestHook,
      postRequestHook = _ref$postRequestHook === void 0 ? function (_ref2) {
    var response = _ref2.response;
    return _await$4(response);
  } : _ref$postRequestHook;
  return function (_ref3) {
    var dispatch = _ref3.dispatch,
        getState = _ref3.getState;
    return function (next) {
      return _async$3(function (action) {
        var _exit = false;
        var state = getState();
        return _invoke$1(function () {
          if (action && action.type) {
            return _awaitIgnored$1(next(action));
          } else {
            _exit = true;
          }
        }, function (_result) {
          if (_exit) return _result;

          if (request === null) {
            request = new Request({
              transport: transport,
              preRequestHook: preRequestHook,
              postRequestHook: postRequestHook
            });
          }

          if (action.type === REMOVE_TOKENS) {
            removeTokens({
              dispatch: dispatch,
              tokenKey: tokenKey
            });
          }

          return _invoke$1(function () {
            if (action.type === STORE_TOKENS) {
              var parsedTokens;
              return _invoke$1(function () {
                if (action.data) {
                  return _await$4(accessTokenAdapters.response({
                    data: action.data,
                    state: state
                  }), function (_accessTokenAdapters$) {
                    parsedTokens = _accessTokenAdapters$;
                  });
                } else {
                  parsedTokens = {
                    access_token: action.access_token,
                    refresh_token: action.refresh_token,
                    scope: state._network.scope
                  };
                }
              }, function () {
                storeTokens({
                  dispatch: dispatch,
                  tokens: parsedTokens,
                  tokenKey: tokenKey
                });
              });
            }
          }, function () {
            return _invoke$1(function () {
              if (action.type === REFRESH_TOKEN) {
                var refreshConfig = refreshTokenAdapters.request({
                  access_token: state._network.access_token[tokenKey],
                  refresh_token: state._network.refresh_token[tokenKey],
                  scope: state._network.scope,
                  decode: function decode(encodedToken) {
                    return jwtDecode__default['default'](encodedToken);
                  }
                });
                return _await$4(request.send({
                  config: refreshConfig,
                  onStart: function onStart(payload) {
                    dispatch(Object.assign({
                      type: REFRESH_TOKEN_START
                    }, payload));
                  },
                  onSuccess: function onSuccess(payload) {
                    dispatch(Object.assign({
                      type: REFRESH_TOKEN_SUCCESS
                    }, payload));
                  },
                  onError: function onError(payload) {
                    dispatch(Object.assign({
                      type: REFRESH_TOKEN_ERROR
                    }, payload));
                  }
                }), function (refreshResponse) {
                  var parsedRefreshTokens = refreshTokenAdapters.response({
                    data: refreshResponse.data
                  });
                  storeTokens({
                    dispatch: dispatch,
                    tokens: parsedRefreshTokens,
                    tokenKey: tokenKey
                  });
                });
              }
            }, function () {
              var _exit2 = false;
              return _invoke$1(function () {
                if (action.type === REQUEST) {
                  var refresh_token = state._network.refresh_token[tokenKey];
                  var access_token = state._network.access_token[tokenKey] || null;
                  return _invoke$1(function () {
                    if (refresh_token && (!access_token || isExpired(access_token))) {
                      return _await$4(refreshToken({
                        tokenKey: tokenKey,
                        refreshTokenAdapters: refreshTokenAdapters,
                        state: state,
                        dispatch: dispatch,
                        request: request
                      }), function (tokens) {
                        access_token = tokens.access_token || tokens.token || null;
                      });
                    }
                  }, function () {
                    var _action$config;

                    var headers = Object.assign({}, (action === null || action === void 0 ? void 0 : (_action$config = action.config) === null || _action$config === void 0 ? void 0 : _action$config.headers) || {});

                    if (access_token) {
                      headers.Authorization = "Bearer ".concat(access_token);
                    }

                    var config = Object.assign({}, action.config, {
                      headers: headers
                    });
                    _exit2 = true;
                    return _await$4(request.send({
                      config: config,
                      onStart: function onStart(payload) {
                        dispatch(Object.assign({
                          type: REQUEST_START
                        }, payload));
                      },
                      onSuccess: function onSuccess(payload) {
                        dispatch(Object.assign({
                          type: REQUEST_SUCCESS
                        }, payload));
                      },
                      onError: function onError(payload) {
                        dispatch(Object.assign({
                          type: REQUEST_ERROR
                        }, payload));
                      }
                    }));
                  });
                }
              }, function (_result2) {
                return _exit2 ? _result2 : function () {
                  if (action.type === GET_TOKEN) {
                    return _await$4(request.send({
                      config: action.config,
                      onStart: function onStart(payload) {
                        dispatch(Object.assign({
                          type: GET_TOKEN_START
                        }, payload));
                      },
                      onSuccess: function onSuccess(payload) {
                        dispatch(Object.assign({
                          type: GET_TOKEN_SUCCESS
                        }, payload));
                      },
                      onError: function onError(payload) {
                        dispatch(Object.assign({
                          type: GET_TOKEN_ERROR
                        }, payload));
                      }
                    }));
                  }
                }();
              });
            });
          });
        });
      });
    };
  };
};

function _awaitIgnored$1(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty$1) : Promise.resolve();
  }
}

var createNetworkMiddleWare = function createNetworkMiddleWare(_ref4) {
  var accessTokenAdapters = _ref4.accessTokenAdapters,
      refreshTokenAdapters = _ref4.refreshTokenAdapters,
      tokenKey = _ref4.tokenKey,
      transport = _ref4.transport,
      preRequestHook = _ref4.preRequestHook,
      postRequestHook = _ref4.postRequestHook;
  return networkMiddleware({
    accessTokenAdapters: accessTokenAdapters,
    refreshTokenAdapters: refreshTokenAdapters,
    tokenKey: tokenKey,
    transport: transport,
    preRequestHook: preRequestHook,
    postRequestHook: postRequestHook
  });
};

function _invoke$1(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

function _async$3(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

exports.GET_TOKEN = GET_TOKEN;
exports.GET_TOKEN_ERROR = GET_TOKEN_ERROR;
exports.GET_TOKEN_START = GET_TOKEN_START;
exports.GET_TOKEN_SUCCESS = GET_TOKEN_SUCCESS;
exports.REFRESH_TOKEN = REFRESH_TOKEN;
exports.REFRESH_TOKEN_ERROR = REFRESH_TOKEN_ERROR;
exports.REFRESH_TOKEN_START = REFRESH_TOKEN_START;
exports.REFRESH_TOKEN_SUCCESS = REFRESH_TOKEN_SUCCESS;
exports.REMOVE_TOKENS = REMOVE_TOKENS;
exports.REMOVE_TOKENS_ERROR = REMOVE_TOKENS_ERROR;
exports.REMOVE_TOKENS_START = REMOVE_TOKENS_START;
exports.REMOVE_TOKENS_SUCCESS = REMOVE_TOKENS_SUCCESS;
exports.REQUEST = REQUEST;
exports.REQUEST_ERROR = REQUEST_ERROR;
exports.REQUEST_START = REQUEST_START;
exports.REQUEST_SUCCESS = REQUEST_SUCCESS;
exports.SET_SCOPE = SET_SCOPE;
exports.STORE_TOKENS = STORE_TOKENS;
exports.STORE_TOKENS_ERROR = STORE_TOKENS_ERROR;
exports.STORE_TOKENS_START = STORE_TOKENS_START;
exports.STORE_TOKENS_SUCCESS = STORE_TOKENS_SUCCESS;
exports._network = reducer;
exports.broadcastChannelTransport = broadcastChannel;
exports.default = createNetworkMiddleWare;
